module.exports = __webpack_public_path__ + "static/adjustable-bed-frame-1-video-thumbnail-dab5f6e3dc8c770ec152d8c1f8ac13cd.png";